<template>

  <div class="page">

    <div class="top"></div>
      <!-- <div class="swiper">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide><img src="../../../images/live-1.png" width="558" /></swiper-slide>
          <swiper-slide><img src="../../../images/live-1.png" width="558" /></swiper-slide>=
        </swiper>
      </div> -->
    <div class="back" @click="back"></div>

    <div class="container" v-show="!clear">

      <div class="btn-switch-left" @click="goPrev"></div>
      <div class="btn-switch-right" @click="goNext"></div>
    
      <div class="scroll">
        <div class="swiper">
          <van-swipe ref="swipe" class="swiper" :show-indicators="false">
            <van-swipe-item v-for="thumb in swiper" :key="thumb">
              <img :src="thumb" />
            </van-swipe-item>
          </van-swipe>
          <!-- <swiper ref="1mySwiper" :options="swiperOptions">
            <swiper-slide><img src="../../../images/live-1.png" width="100%"/></swiper-slide>
            <swiper-slide><img src="../../../images/live-1.png" width="100%"/></swiper-slide>
          </swiper> -->
        </div>
        <div class="content">
          <img src="../../../images/index/live-content.png" width="100%"/>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import { Swipe, SwipeItem } from "vant";
// import "swiper/dist/css/swiper.css";
// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      clear: false,
      swiper: [
        require("@/images/index/live-1.png"),
        require("@/images/index/live-2.png")
      ],
      // swiperOptions: {
      //   preventInteractionOnTransition : true,
      //   pagination: {
      //     el: '.swiper-pagination'
      //   },
      // }
    };
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    // swiper,
    // swiperSlide,
  },
  mounted() {
    // new Swiper ('.swiper-container', {
    //   loop: true,
    //   // 如果需要分页器
    //   pagination: '.swiper-pagination',
    //   // 如果需要前进后退按钮
    //   nextButton: '.swiper-button-next',
    //   prevButton: '.swiper-button-prev',
    //   // 如果需要滚动条
    //   scrollbar: '.swiper-scrollbar',
    // })
  },
  methods: {
    goPrev() {
      // let swiper = this.$refs.mySwiper.swiper;
      // swiper.slidePrev();
      this.$refs.swipe.prev();
    },
    goNext() {
      // let swiper = this.$refs.mySwiper.swiper;
      // swiper.slideNext();
      this.$refs.swipe.next();
    },
    back() {
      this.$emit("back");
    },
    onClear(e) {
      this.clear = e;
    },
    onClose() {
      this.clear = false;
    },
  },
};
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  background: url("../../../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
}
.top {
  z-index: 2;
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 209px;
  background: url("../../../images/title-live.png") no-repeat;
  background-size: 100%;
}
// .swiper {
//   width: 558px;
//   height: 575px;
//   overflow: hidden;
//   .swiper-wrapper {
//     position: relative;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     .swiper-slide {
//       flex-shrink: 0;
//       width: 100%;
//       height: 100%;
//       position: relative;
//     }
//   }
// }
.back {
  position: absolute;
  z-index: 2;
  left: 50px;
  bottom: 70%;
  width: 342px;
  height: 126px;
  background: url("../../../images/btn-back.png") no-repeat;
  background-size: 100%;
}
.container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4%;
  margin: 0 auto;
  overflow-y: scroll;
  height: 1000px;
  width: 100%;
  text-align: center;
  .btn-switch-left {
    position: absolute;
    left: 45px;
    top: 280px;
    width: 77px;
    height: 82px;
    background: url("../../../images/btn-switch-left.png") no-repeat;
    background-size: 100%;
  }
  .btn-switch-right {
    position: absolute;
    right: 45px;
    top: 280px;
    width: 77px;
    height: 82px;
    background: url("../../../images/btn-switch-right.png") no-repeat;
    background-size: 100%;
  }
  .scroll {
    width: 560px;
    height: 1526px;
    text-align: center;
    padding-top: 50px;
    margin: 0 auto;
    background: url("../../../images/index/bg-live.png") no-repeat center 540px;
    background-size: 559px 177px;
    .swiper {
      width: 554px;
      height: 570px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .swiper-slide {
        width: 554px;
        height: 570px;
        float: left;  
      }
    }
  }
}
</style>
